import { createContext } from 'react';
import { ITableState } from './ITableState';

export const initState: ITableState = {
  sortData: {order: '', direction: 'desc'},
  setSortData: ()=> {}
}
export const TableContext = createContext(initState)
